import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  drawerItem: css`
    color: ${colors.prussian};
  `,
};

export default styles;
